<script lang="ts">
    export let hover: string = '';
    export let src: string = '';
    export let alt: string = '';
    export let scale: number = 1;
    export let style: string = '';
    export let styleElement: string = '';
    export let spin: boolean = false;
    export let disabled: boolean = false;
</script>

<div
    on:click
    class:spin
    title={hover}
    style="width:{30 * scale}px; height:{30 * scale}px; {styleElement}"
    class="icon"
    class:disabled
>
    <img {src} {alt} style="width:{30 * scale}px; height:{30 * scale}px; {style}" />
</div>

<style lang="scss">
  .icon {
    display: flex;
    align-items: center;
  }
    .icon:hover {
        cursor: pointer;
    }
    @keyframes spin-animate {
        from {
            transform: rotate(0deg);
        }
        to {
            transform: rotate(360deg);
        }
    }

    .spin {
        // filter: blur(1px) brightness(0.8) saturate(0.8) contrast(1.2);
        //transform: scale(0.8);
        animation: spin-animate 0.3s linear infinite;
    }
    .disabled {
        opacity: 0.25;
        pointer-events: none;
    }
</style>
